<template>
  <div class="msg-overlay" v-if="isLandscape">
    <div class="msg-content">
      <div>
        <img :src="require('@/assets/imgs/orientation.png')">
        <p class="mt-4" v-html="$t('shared.landscape_rotate_message')"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';

export default {
  name: "LandscapeMessage",
  data() {
    return {
      isLandscape: false
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleOrientationChange);
    this.handleOrientationChange();
  },
  methods: {
    handleOrientationChange() {
      if(isMobile && window.innerWidth > window.innerHeight) {
        this.isLandscape = true;
      } else {
        this.isLandscape = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.msg-overlay {
  &:before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    opacity: 0.8;
    background: #000;
    z-index: 3;
  }
  .msg-content {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    color: #fff;
    max-width: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    z-index: 3;
    img {
      height: 200px;
      margin: 0 auto;
      display: flex;
    }
    p {
      text-align: center;
    }
  }
}
</style>
